module.exports = __webpack_public_path__ + "media/bootstrap-icons/inboxes-fill-1bc9f468.svg";